<template>
  <div class="refinement-options -skeleton">
    <!-- closer -->
    <div class="content-refinement-actions mobile-filters">
      <div class="results-actions">
        <div class="action"></div>
      </div>
    </div>

    <div class="refinement search">
      <div class="refinement-header">
        <div class="title"></div>
        <div class="search-form"></div>
      </div>
    </div>

    <div class="refinement search">
      <div class="refinement-header">
        <div class="title"></div>
        <div class="search-form"></div>
      </div>
    </div>

    <div class="refinement options">
      <div class="refinement-header expander">
        <div class="title"></div>
        <div class="expand-collapse"></div>
      </div>
      <div class="refinement-grouping">
        <div class="refinement-category">
          <ul class="refinement-list">
            <li v-for="itemNum in 18" :key="`refinement-item-${itemNum}`">
              <span class="checkbox"></span>
              <span class="label"></span>
              <span class="option-count"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="refinement options">
      <div class="refinement-header expander">
        <div class="title"></div>
        <div class="expand-collapse"></div>
      </div>
      <div class="refinement-grouping">
        <div class="refinement-category">
          <ul class="refinement-list">
            <li v-for="itemNum in 18" :key="`refinement-item-${itemNum}`">
              <span class="checkbox"></span>
              <span class="label"></span>
              <span class="option-count"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts"></script>
